import React from 'react';

import cls from 'classnames';
import styles from './CallIcon.scss';

function CallIcon({ w, h, style, theme, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cls(className, styles.CallIcon, styles[theme])}
      width={w}
      height={h}
      style={style}
      viewBox="0 0 36 36"
    >
      <g fill="none" fillRule="evenodd">
        <circle cx="18" cy="18" r="18" className={styles.circle} />
        <path d="M7.2 7.2h21.6v21.6H7.2" />
        <path
          d="M13.158 16.91c1.296 2.548 3.384 4.627 5.93 5.932l1.98-1.98c.244-.243.604-.324.92-.216 1.007.333 2.096.513 3.212.513.495 0 .9.404.9.9v3.14c0 .495-.405.9-.9.9-8.45 0-15.3-6.85-15.3-15.3 0-.495.405-.9.9-.9h3.15c.495 0 .9.405.9.9 0 1.125.18 2.205.513 3.213.1.315.027.666-.225.918l-1.98 1.98z"
          className={styles.phone}
        />
      </g>
    </svg>
  );
}

CallIcon.defaultProps = {
  w: 36,
  h: 36,
  theme: 'default',
};

export default CallIcon;
